import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { Student } from '../student.js';

export const editStudentSubjectsMutation = registerMutation({
  operationName: 'editStudentSubjectsMutation',
  type: () => Boolean,
  params: [{ name: 'subjects', type: () => [String] }],
  resolve: (subjects: string[]) => async () => {
    const sessionData = await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 });

    if (!sessionData?.userID) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const normalizedSubjects = subjects.map(subject => subject.trim()).filter(subject => subject.length > 0);

    const studentCollection = await getCollection(Student);

    const result = await studentCollection.updateOne(
      { userID: sessionData.userID },
      { $set: { subjects: normalizedSubjects } },
    );

    return result.matchedCount > 0;
  },
});

/** Mirrors `editTeacherMutation` for a student account, minus the subjects — those are the teacher's
 * teaching profile, and a student's list is not edited from the profile page. */
export const editStudentMutation = registerMutation({
  operationName: 'editStudentMutation',
  type: () => Boolean,
  params: [
    { name: 'firstName', type: () => String },
    { name: 'lastName', type: () => String },
    { name: 'school', type: () => String },
  ],
  resolve: (firstName: string, lastName: string, school: string) => async () => {
    const sessionData = await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 });

    if (!sessionData?.userID) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const studentCollection = await getCollection(Student);

    const result = await studentCollection.updateOne(
      { userID: sessionData.userID },
      {
        $set: {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          school: school.trim(),
        },
      },
    );

    return result.matchedCount > 0;
  },
});
